import { assign } from 'xstate';

import { Context, SetExpandStateEvent } from './types';

export const setCatalogExpandState = assign({
  expandedCatalogItems: (context: Context, event: SetExpandStateEvent) => {
    const { catalogId, isExpanded } = event;
    return isExpanded
      ? [...context.expandedCatalogItems, catalogId]
      : context.expandedCatalogItems.filter((id) => id !== catalogId);
  },
});
